<!-- prettier-ignore -->

<div class="subHeaderCity">
    <h2>{{'¡Tenemos estas rutas preparadas para ti!' | translate}}</h2>
</div>
<div scrollControl #scrollDirective="scrollDirective" class="cardsScrollContainer routeScrollWrapper">
    <span class="goLeftCardsScrollContainer eventGoLeft" scrollControl> < </span>
    <span class="goRightCardsScrollContainer eventGoRight" scrollControl> > </span>
    <div class="cardsContainer eventContainer" scrollControl>
        @for (route of item; track $index) {
            <cicerone-route-card class="itemPoints" [item]="route" />
        }
    </div>
</div>